var $JQ = jQuery.noConflict(),
    actClass = 'active';

(function ($) {
    $.fn.addAccess = function (options) {
        var settings = $.extend({
            //default settings
            role: 'button',
            tabindex: '0'
        }, options);

        $(this).attr('tabindex', settings.tabindex).attr('role', settings.role).on('keyup.access', function (e) {
            var keyCode = e.which;
            if ((keyCode === 13) || (keyCode === 32)) {
                $(this).click();
            }
        });
    };

    $.fn.removeAccess = function () {
        $(this).removeAttr('tabindex').removeAttr('role').off('keyup.access');
    };
})($JQ);

(function ($) {
    $.fn.animateScroll = function (options) {

        var settings = $.extend({
            // default settings
            scrollToEl: this,
            speed: 600,
            offset: [
                { minWidth: 0, offsetSize: 0, offsetEl: null }
            ]
        }, options);

        this.on("click", function () {

            var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                highestOffset = 0,
                offset = 0,
                scrollToEl = settings.scrollToEl;

            $.each(settings.offset, function (i, val) {
                if (viewportWidth >= val.minWidth && highestOffset < val.minWidth) {
                    offset = 0;

                    if (("offsetSize" in val)) {
                        offset = val.offsetSize;
                    }
                    if (("offsetEl" in val) && val.offsetEl.length) {
                        var offsetEl = val.offsetEl.first();
                        var offsetElSize = offsetEl.outerHeight(true);
                        offset = offset + offsetElSize;
                    }

                    highestOffset = val.minWidth;
                }
            });


            $('html, body').animate({
                scrollTop: scrollToEl.offset().top - offset
            }, settings.speed);
        });

        return this;
    };
})($JQ);

(function ($) {
    $.fn.isElementInViewport = function (options) {

        var settings = $.extend({
            // default settings
            visibleOffset: null,
            visibleMinimum: 0
        }, options);

        var checkEl = this[0],
            rect = checkEl.getBoundingClientRect(),
            inViewportLimit = rect.bottom,
            visibleOffset = settings.visibleOffset,
            visibleMinimum = settings.visibleMinimum;

        if (visibleOffset === null) {
            if (rect.height <= (window.innerHeight * .25 || document.documentElement.clientHeight * .25)) {
                visibleOffset = 1;
            } else if (rect.height <= (window.innerHeight * .8 || document.documentElement.clientHeight * .8)) {
                visibleOffset = .5;
            } else {
                visibleOffset = .1;
            }
        }

        inViewportLimit = rect.top + Math.floor(rect.height * visibleOffset);

        if (visibleMinimum) {
            if (inViewportLimit < visibleMinimum) {
                inViewportLimit = visibleMinimum;
            }
        }

        return (
            rect.bottom >= 0 &&
            rect.left >= 0 &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            inViewportLimit <= (window.innerHeight || document.documentElement.clientHeight)
        );
    };
})($JQ);

(function ($) {
    $.fn.addViewportClass = function (options) {

        var settings = $.extend({
            // default settings
            viewEl: this,
            class: "inView",
            visibleOffset: null,
            visibleMinimum: 0,
            triggerScroll: false,
        }, options);

        var $window = $(window);

        if (typeof $addViewportClassElements !== 'undefined' && $addViewportClassElements.length > 0) {
            $addViewportClassElements.push(settings);
        } else {
            $addViewportClassElements = [settings];
        }

        if ($addViewportClassElements.length) {
            $window.off('scroll.viewportClass');
            $window.on('scroll.viewportClass', $.throttle(25, true, function () {
                for (var i = 0; i < $addViewportClassElements.length; i++) {
                    $addViewportClassElements[i].viewEl.each(function (idx, itm) {
                        isInView = $(this).isElementInViewport({
                            visibleOffset: $addViewportClassElements[i].visibleOffset,
                            visibleMinimum: $addViewportClassElements[i].visibleMinimum
                        });
                        if (isInView) {
                            $(this).addClass($addViewportClassElements[i].class);
                        }
                    });
                }
            }));
        }

        if (settings.triggerScroll) {
            $window.trigger('scroll');
        }
    }

})($JQ);

(function ($) {
    $(function () {
        var $html = $('html'),
            $body = $('body'),
            $window = $(window),
            $mainMenu = $('[data-selector-id="header"]:not(.stickyClone) [data-selector-id="main-menu"]'),
            $toggleMenu = $('[data-selector-id="menu-toggle"]'),
            navOpen = 'nav-open',
            $mainNav = $('[data-selector-id="main-nav"]'),
            $navPanel = $mainMenu.find('a').next('.stage'),
            $topLink = $navPanel.prev('a'),
            $tools = $('[data-selector-id="header"]:not(.stickyClone) [data-selector-id="tools"]'),
            $toggleTools = $('[data-selector-id="header"]:not(.stickyClone) [data-selector-id="tools-toggle"]'),
            $toggleSearch = $('[data-selector-id="search-toggle"] > a'),
            $mainSearch = $('[data-selector-id="main-search"]'),
            $sidebarNav = $('[data-selector-id="sidebar"] .section-nav'),
            moves = [
                {
                    min: 0,
                    max: 1199,
                    enter: function () {
                        bindNav();
                        bindsMenu();
                        bindsSectionNav();
                        $mainMenu.css('transition', 'all .6s');
                    },
                    exit: function () {
                        unbindNav();
                        unbindsMenu();
                        unbindsSectionNav();
                        $mainMenu.removeAttr('style');
                    }
                },
                {
                    min: 1200,
                    max: 99999,
                    enter: function () {
                        xlPlacement();
                        bindxlMenu();
                        makeSticky();

                        makeSticky({
                            "stickyClass": "sticky-sidebar",
                            "offsetTop": $('[data-selector-id="header"]'),
                            "sidebar": true
                        });
                    },
                    exit: function () {
                        xlReset();
                        unbindxlMenu();
                        unSticky();

                        unSticky({
                            "stickyClass": "sticky-sidebar"
                        });
                    }
                }
            ];

        bindNav = function () {
            //function to close nav if clicked out of
            $(document).on('click.navToggle', function (e) {
                e.stopPropagation();
                if ($body.hasClass(navOpen) && !$mainMenu.find(e.target).length) {
                    $body.removeClass(navOpen);
                } else if ($(e.target).is($toggleMenu)) {
                    $body.addClass(navOpen);
                } 
            });

            $(document).on('keydown', function (e) {
                if (e.keyCode === 27) {
                    $body.removeClass(navOpen);
                }
            });

            $mainMenu.on('click', function (e) {
                e.stopPropagation();
            });

            // accessibility support
            $toggleMenu.addAccess();

        }

        unbindNav = function () {
            $(document).off('click.navToggle');
            $mainMenu.off('click');
            $toggleMenu.removeAccess();
            $body.removeClass('nav-open');
        }

        xlPlacement = function () {
            $tools.insertBefore('#header-wrap');
            //$toggleTools.appendTo('[data-selector-id="sub-nav"]');
            $toggleTools.insertBefore($($('[data-selector-id="header"] .give-link')[0]));
            $mainSearch.appendTo($($('[data-selector-id="header"]')[0]));
        };

        xlReset = function () {
            $tools.insertAfter($($('[data-selector-id="sub-nav"]')[0]));
            //$toggleTools.appendTo('[data-selector-id="sub-nav"]');
            $toggleTools.insertBefore($($('[data-selector-id="header"] .give-link')[0]));
            $mainSearch.prependTo($($('[data-selector-id="main-menu"]')[0]));
        };

        bindsMenu = function () {
            $topLink.on('click.sMenu', function (e) {
                e.preventDefault();
                var $this = $(this),
                    $parent = $this.parent('li');

                if ($parent.hasClass(actClass)) {
                    $parent.removeClass(actClass).find('.stage').slideUp('400');
                } else {
                    $mainNav.find('.active').removeClass(actClass).find('.stage').slideUp('200');
                    $this.parent('li').toggleClass(actClass).find('.stage').slideDown('200');
                }

            });

            //$(document).on('keydown', function (e) {
            //    if (e.keyCode === 27) {
            //        $body.removeClass('main-nav');
            //    }
            //});
        };

        unbindsMenu = function () {
            $topLink.off('click.sMenu');
            $mainNav.find('.active').removeClass(actClass).find('.stage').removeAttr('style');
        };

        collapseMenu = function (e) {
            if (e.keyCode === 27) {
                unbindsMenu();
            }
        };

        bindxlMenu = function () {
            $topLink.on('click.xlMenu', function (e) {
                e.preventDefault();
                var $this = $(this),
                    $parent = $this.parent('li');

                if ($parent.hasClass(actClass)) {
                    $parent.removeClass(actClass).find('.stage').fadeOut('100');
                } else {
                    $mainNav.find('.active').removeClass(actClass).find('.stage').fadeOut('100');

                    if ($mainSearch.is(':visible')) {
                        $mainSearch.slideUp('200');
                    }

                    $this.parent('li').toggleClass(actClass).find('.stage').fadeIn('200');
                    bindClickOff();
                }
            });

            document.addEventListener('keydown', collapseMenu);

            $toggleSearch.on('click.searchStage', function (e) {
                e.preventDefault();
                $(this).toggleClass(actClass);
                $mainSearch.slideToggle('200');
                $('[data-selector-id="main-search-box"]').focus();
            });
        };

        unbindxlMenu = function () {
            $topLink.off('click.xlMenu');
            $toggleSearch.off('click.searchStage').removeClass(actClass);
            $mainSearch.removeAttr('style');
        };

        bindClickOff = function () {
            $(document).on('click.menuStage', function (e) {
                if (!$mainNav.is(e.target) && $mainNav.has(e.target).length === 0 || $toggleSearch.is(e.target)) {
                    $navPanel.fadeOut('100').parent('li').removeClass(actClass);
                    unbindClickOff();
                }
            });
        }

        unbindClickOff = function () {
            $(document).off('click.menuStage');
        }

        bindsSectionNav = function () {
            $sidebarNav.find('a.title').on('click.sectionNav', function (e) {
                e.preventDefault();
                $(this).toggleClass(actClass).next('.stage').slideToggle('400');
            });
        }

        unbindsSectionNav = function () {
            $sidebarNav.find('a.title').off('click.sectionNav').removeClass(actClass);
            $sidebarNav.find('.stage').removeAttr('style');
        }

        $toggleTools.on('click', function (e) {
            e.preventDefault();
            $toggleTools.toggleClass(actClass);
            $tools.find('ul').slideToggle('200', function () {
                $window.trigger('resize');
            });

            // accessibility fix
            if ($toggleTools.hasClass(actClass)) {
                $tools.find('a').eq(0).focus();
            }
        });

        // accessibility fix
        $tools.find('a').last().on('blur', function () {
            $toggleTools.focus();
        });

        breakdance(moves);

        var $alert = $('#alert'),
            $toggleAlert = $('#alert-toggle'),
            cookies = document.cookie.split(';');
        if ($alert.length) {
            $toggleAlert.addAccess();

            var showAlert = true;
            for (var i = 0; i < cookies.length; i++) {
                if (cookies[i].split('=')[1] == 'alertClosed') {
                    var showAlert = false;
                    break;
                }
            }

            if (showAlert) {
                $alert.addClass(actClass).find('.alert-info').slideDown('200', function () {
                    $window.trigger('resize');
                });
            }

            $toggleAlert.on('click', function () {

                $alert.toggleClass(actClass).find('.alert-info').slideToggle('200', function () {
                    $window.trigger('resize');
                });
                if (showAlert) {
                    // write cookie to expire when browser is closed
                    document.cookie = "name=alertClosed;path=/";
                }

            });
        }

        // class rows that don't have backgrounds
        $('.endicott-row').each(function (idx, itm) {
            var row = $(itm);

            if (row.attr('class') == 'endicott-row' && row.attr('id') != 'page-top') {
                row.addClass('bg-white');
            }
        });

        // responsive background images
        var banner = $('#banner-image'),
            bannerMedium = 'url(' + banner.attr('data-bg-medium') + ')',
            bannerLarge = 'url(' + banner.attr('data-bg-large') + ')',
            bannerFull = 'url(' + banner.attr('data-bg-full') + ')',
            bannerExists = false;

        if (bannerMedium != 'url(undefined)' &&
            bannerLarge != 'url(undefined)' &&
            bannerFull != 'url(undefined)') {

            var bannerMoves = [
                {
                    min: 0,
                    max: 960,
                    enter: function () {
                        if (!bannerExists) {
                            banner.css('background-image', bannerMedium).addClass('active');
                            bannerExists = true;
                        }
                    },
                    exit: function () { }
                },
                {
                    min: 961,
                    max: 1920,
                    enter: function () {
                        if (!bannerExists) {
                            banner.css('background-image', bannerLarge).addClass('active');
                            bannerExists = true;
                        }
                    },
                    exit: function () { }
                },
                {
                    min: 1921,
                    max: 9999,
                    enter: function () {
                        if (!bannerExists) {
                            banner.css('background-image', bannerFull).addClass('active');
                            bannerExists = true;
                        }
                    },
                    exit: function () { }
                }
            ];

            breakdance(bannerMoves);
        }

        $window.on('load', function () {
            $window.trigger('resize');
        });
        $window.on('orientationchange', function () {
            $window.trigger('resize');
        });
    });
})($JQ);


(function ($) {


    $(window).bind("load", function () {
        var pageUrlBase = window.location.href.split('?')[0];
        var fullPageUrl = window.location.href;

        var nextUrl = $("a[rel='next']").attr("href");
        var prevUrl = $("a[rel='prev']").attr("href");

        var head = document.getElementsByTagName('head')[0];

        var canonLink = document.createElement("link");
        canonLink.rel = "canonical";
        //dont include page=1 on first page 
        if (fullPageUrl.indexOf("?page=1") >= 0) {
            canonLink.href = pageUrlBase;
        }
        else {
            canonLink.href = fullPageUrl;
        }

        var nextLink = document.createElement("link");
        nextLink.rel = "next";
        nextLink.href = pageUrlBase + nextUrl;

        var prevLink = document.createElement("link");
        prevLink.rel = "prev";
        prevLink.href = pageUrlBase + prevUrl;

        head.appendChild(canonLink);

        if (nextUrl != null) {
            head.appendChild(nextLink);
        }
        if (prevUrl != null) {
            head.appendChild(prevLink);
        }
    });

    

})($JQ);